import { HeroId } from "../../../../shared/src/index.ts";
import type { VoiceScript } from "../voice-types.ts";

const script = {
  hero: HeroId.ScarletTwitch,
  voices: {
    main: {
      description:
        "high-strung alto chaos witch, rapid glitchy cadence, playful panic and unstable confidence, close dry mic with tiny digital stutters",
      seed: 10649,
      guidance: 0.76,
      loudness: 0.78,
      fx: { doubler: true, eq: "bright" },
    },
  },
  lines: {
    select: [
      {
        id: "select_1",
        text: "You don't have to be a witch to find the magic in this world. But it does help.",
      },
      { id: "select_2", text: "The Scarlet Twitch awaits your call." },
      { id: "select_3", text: "I'm ready to cause some chaos." },
      { id: "select_4", text: "Summon the Scarlet Twitch!" },
      { id: "select_5", text: "Sooner or later, every man shows himself." },
    ],
    spawn: [
      {
        id: "spawn_1",
        text: "Let's see if I can remember that new spell Stephen taught me…",
      },
      {
        id: "spawn_2",
        text: "With both of our magic together, Stephen, our foes won't know what hit them!",
      },
      {
        id: "spawn_3",
        text: "Hmm. A different kind of chaos… How delightful!",
      },
      {
        id: "spawn_4",
        text: "Unleash your chaos, Jubilee, and let it flow through me!",
      },
      {
        id: "spawn_5",
        text: "After all this time, it's nice to finally have some help saving the universe.",
      },
      {
        id: "spawn_6",
        text: "We must stop Doom's schemes before reality unravels around us.",
      },
      {
        id: "spawn_7",
        text: "The barriers between dimensions are breaking down. It's up to us to protect them.",
      },
      {
        id: "spawn_8",
        text: "Of all the possible realities, this is not the one I expected to find myself in.",
      },
      {
        id: "spawn_9",
        text: "When will these madmen learn that reality isn't their plaything?",
      },
      {
        id: "spawn_10",
        text: "I may be powered by chaos, but I'm trying to bring a bit of order to the universe.",
      },
      {
        id: "spawn_11",
        text: "Chaos surrounds us. But I will gladly show it who is in control.",
      },
      {
        id: "spawn_12",
        text: "I've made my share of mistakes, but I'm fighting every day to make amends.",
      },
      {
        id: "spawn_13",
        text: "Magneto raised me to never stop fighting for what I believe is right.",
      },
      {
        id: "spawn_14",
        text: "There's no reason to be afraid of my magic… unless you give me one.",
      },
      {
        id: "spawn_15",
        text: "I've watched entire realities consumed by chaos. I won't let that happen again.",
      },
      {
        id: "spawn_16",
        text: "The multiverse offers endless possibilities, but only if it survives this chaos.",
      },
      {
        id: "spawn_17",
        text: "I saw Stark's fear, I knew it would control him, make him self-destruct.",
      },
      { id: "spawn_18", text: "Ultron has come to end the Avengers." },
      { id: "spawn_19", text: "Everybody's afraid of something." },
      {
        id: "spawn_20",
        text: "I looked in the Vision's head and saw annihilation.",
      },
      { id: "spawn_21", text: "I want to finish the plan." },
    ],
    respawn: [
      { id: "respawn_1", text: "My work here isn't done." },
      { id: "respawn_2", text: "Reborn from the chaos." },
      { id: "respawn_3", text: "My fate isn't sealed yet." },
      { id: "respawn_4", text: "I won't make the same mistakes again." },
    ],
    ult_ally: [{ id: "ult_ally", text: "The perfect hex." }],
    ult_enemy: [{ id: "ult_enemy", text: "Pure chaos!" }],
    ability2: [
      { id: "ability2_1", text: "You're under my spell." },
      { id: "ability2_2", text: "Chaos control!" },
      { id: "ability2_3", text: "You're not going anywhere." },
    ],
    ability1: [
      { id: "ability1_1", text: "Now, a disappearing act…" },
      { id: "ability1_2", text: "Be right back…" },
      { id: "ability1_3", text: "Goodbye… for now…" },
    ],
    kill: [
      { id: "kill_1", text: "Simply magical." },
      { id: "kill_2", text: "That did the trick." },
      { id: "kill_3", text: "Chaos always prevails." },
      { id: "kill_4", text: "Well? Who's next?" },
      { id: "kill_5", text: "Show's over." },
    ],
    multikill: [
      { id: "multikill_1", text: "That's three of them." },
      { id: "multikill_2", text: "Three down. More to go." },
      { id: "multikill_3", text: "I got another one." },
      { id: "multikill_4", text: "Five is good, but not enough." },
      { id: "multikill_5", text: "Still a few more left." },
      { id: "multikill_6", text: "Good. But I can't stop yet." },
      { id: "multikill_7", text: "It seems we're done here." },
      { id: "multikill_8", text: "A perfect performance." },
      { id: "multikill_9", text: "Time for me to take a bow." },
    ],
    low_hp: [
      { id: "low_hp_1", text: "That really helped." },
      { id: "low_hp_2", text: "I'm much better now." },
    ],
    healed: [
      { id: "healed_1", text: "Ah… That's better…" },
      { id: "healed_2", text: "Feeling stronger already." },
      { id: "healed_3", text: "This should help me heal." },
      { id: "healed_4", text: "Just what I needed." },
    ],
  },
} satisfies VoiceScript;

export default script;
